import { cookieBanner } from '@/requests/home-requests'
import { ref } from 'vue'

export function useCookieBanner() {
	const userCookieAnswer = localStorage.getItem('cookie-banner')
	const gtmId = import.meta.env.VITE_GTM_ID
	const showCookieBanner = ref(false)
	const shouldShowCookieBanner = !userCookieAnswer
	const text = ref()

	const setCookieBannerAnswerAndCloseBanner = (userAnswer) => {
		showCookieBanner.value = false
		localStorage.setItem('cookie-banner', userAnswer ? 'accepted' : 'declined')
	}

	const ensureGtag = () => {
		window.dataLayer = window.dataLayer || []
		// évite de redéclarer gtag si déjà défini
		if (typeof window.gtag !== 'function') {
			window.gtag = function() { window.dataLayer.push(arguments) }
		}
	}

	const publishConsentGranted = () => {
		ensureGtag()
		window.gtag('consent', 'update', {
			ad_storage: 'granted',
			analytics_storage: 'granted',
			ad_user_data: 'granted',
			ad_personalization: 'granted'
		})
	}

	const publishConsentDenied = () => {
		ensureGtag()
		window.gtag('consent', 'update', {
			ad_storage: 'denied',
			analytics_storage: 'denied',
			ad_user_data: 'denied',
			ad_personalization: 'denied'
		})
	}

	const accept = () => {
		setCookieBannerAnswerAndCloseBanner(true)
		publishConsentGranted()
		addAnalytics(gtmId)
	}

	const decline = () => {
		setCookieBannerAnswerAndCloseBanner(false)
		publishConsentDenied()
	}

	if (userCookieAnswer === 'accepted') {
		// Republier le consentement pour les sessions suivantes
		publishConsentGranted()
		addAnalytics(gtmId)
	}

	if (shouldShowCookieBanner) {
		setTimeout(async () => {
			const cookieBannerContent = await cookieBanner()
			text.value = cookieBannerContent?.html
			showCookieBanner.value = !!text.value
		})
	}
	return { showCookieBanner, accept, decline, tapText, text }
}

const addAnalytics = (gtmId) => {
	if (import.meta.env.PROD && gtmId) {
		// Prevent double injection if user accepted earlier or function is called twice
		if (window.__gtmLoaded) return
		const scripts = document.getElementsByTagName('script')
		for (let i = 0; i < scripts.length; i++) {
			const src = scripts[i].getAttribute('src') || ''
			if (src.indexOf('https://www.googletagmanager.com/gtm.js?id=' + gtmId) === 0) {
				window.__gtmLoaded = true
				return
			}
		}

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
		const firstScript = document.getElementsByTagName('script')[0]
		const j = document.createElement('script')
		j.async = true
		j.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmId
		firstScript.parentNode.insertBefore(j, firstScript)
		window.__gtmLoaded = true
	}
}

const tapText = (e) => {
	if (e.target.nodeName === 'A') {
		window.open('https://affordance-terms-and-conditions.s3.amazonaws.com/Politique_Lio.pdf', '_blank')
	}
}
